import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser'

@Component({
  selector: 'app-pickup-order-window',
  templateUrl: './pickup-order-window.component.html',
  styleUrls: ['./pickup-order-window.component.css']
})
export class PickupOrderWindowComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('/doctororders/pickedUp');
  }

}
